import { takeEvery, put, call } from 'redux-saga/effects';

import { getStoreById } from 'yoda-interfaces/lib/Order/StoreApi';
import { GET_STORE_INFO_SUCCESS, GET_STORE_INFO_REQUEST } from '../actionTypes/OrderActionTypes';

function* storeInfoSaga(storeAction) {
    try {
        const response = yield call(getStoreById, storeAction);
        let storeDetails = {};
        if (response && response.data) {
            // eslint-disable-next-line prefer-destructuring
            storeDetails = response.data.stores[0];
        }
        yield put({ type: GET_STORE_INFO_SUCCESS, storeDetails });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
}

const watchStoreInfoSaga = function* watchStoreInfoSaga() {
    yield takeEvery(GET_STORE_INFO_REQUEST, storeInfoSaga);
};
watchStoreInfoSaga.sagaName = 'watchStoreInfoSaga';

export default watchStoreInfoSaga;
